import { SavedSearchAlertType } from '../../types/savedSearch.types';

export const ALERT_TYPE_META: Record<
  SavedSearchAlertType,
  { icon: string; label: string }
> = {
  info: { icon: 'bell', label: 'Information' },
  warning: { icon: 'alert-triangle', label: 'Attention' },
  critical: { icon: 'zap', label: 'Critique' },
};
